

  export async function getUnexpectedStockOutflow(repository, id) {
    if (!id) {
      throw new Error('El ID es requerido')
    }

    const outflow = await repository.get(id)
    if (!outflow) {
      throw new Error('Salida extraordinaria no encontrada')
    }

    return outflow
  }
